<script>
    export default {
        props: ['educator', 'editable'],
        mounted () {   

        },
        data() {
            return {
                editing: false,
                desc: "placeholder"
            }
        },
        methods: {      
          dismiss() {
            this.editing = false;
          },
          openModal() {
            if ( this.educator.description ) {
              this.desc  = this.educator.description
            }
            this.editing = true
          },
          save() {
            this.educator.description = this.desc
            console.log("emitting save")
            this.$emit('save')
            this.editing=false
          }
        }
        
    }
</script>



<template lang="pug">

.foo
  #info.z-depth-1
    .row.edit-div(v-if="editable")
      .col.s12.right-align
        img.edit-icon.modal-trigger(
          data-target='industry-intro-modal' 
          src='@/assets/svg/bluepencil.svg' 
          @click="openModal")
    .info-container  
      .row
        h6 Introduction
        //Edit info div if company has no information
        #no-info.col.s12.edit-div( 
          v-if="!educator.description && editable")
          img.edit-icon.modal-trigger(
            data-target='industry-intro-modal' 
            src='@/assets/svg/blueplussign.svg'
            @click="openModal")
          span Add a short description of your business and what you do!
        #intro( v-else )
          p#introduction(v-if="educator.description")
            pre.description_pre {{educator.description}}  
          p#introduction.no-content(v-else) No description available

  #industry-intro-modal(v-if="editing")
    .modal-overlay2(@click="dismiss")
      .modal-content( @click.stop="" )
        .row
          .col.s12.header-lgn
            h5.center-align Introduction
            hr
        .row
          .col.s12
            p
              | Introduce yourself! Type a short description of yourself.
        .row
          .col.s12.input-field
            textarea.materialize-textarea#educ-intro( v-model="desc" )
          .row
            .col.s12.close-btn-div
              button.close-btn.modal-close#save-intro(type='button' @click="save") SAVE
            .col.s12.close-btn-div
              button.close-btn.modal-close(type='button' @click="dismiss") CANCEL


</template>



<style lang="sass" scoped>

.description_pre
  font-family: Muli, sans-serif;
  white-space: pre-wrap;       /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
  white-space: -pre-wrap;      /* Opera 4-6 */
  white-space: -o-pre-wrap;    /* Opera 7 */
  word-wrap: break-word;       /* Internet Explorer 5.5+ */  


.no-content
  font-size: .8em

/*****************************************/
//introduction css
/*****************************************/

#info 
  margin-top: 1em;
  padding: .5em;
  background-color: #fff;


#info, #opps 
  padding: .5em;


#info h6, #opps h6 
  //margin-top: -10px;
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: normal;



#no-info span, #no-opps span 
  font-size: 12px;
  color: #bbbbbb;


#no-info img 
  margin: 0;


// /*****************************************/
// // intro box css
// /*****************************************/

#intro pre 
  margin: 0;


#company-intro 
  border: 1px black solid;
  padding-left: .25em !important;
  height: 300px !important;



</style>